import { render } from "./dashboard.html?vue&type=template&id=a5a866a2&scoped=true&ts=true"
import script from "./dashboard.ts?vue&type=script&lang=ts"
export * from "./dashboard.ts?vue&type=script&lang=ts"

import "./dashboard.scss?vue&type=style&index=0&id=a5a866a2&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5a866a2"]])

export default __exports__